import React from 'react';
import PropTypes from 'prop-types';
import { Segment, Accordion } from 'semantic-ui-react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Icon, TextWidget } from '@plone/volto/components';
import upSVG from '@plone/volto/icons/up-key.svg';
import downSVG from '@plone/volto/icons/down-key.svg';
import { defineMessages, useIntl } from 'react-intl';
import IconWidget from '../../manage/Widgets/IconWidget';

import icon_68 from '../../../assets/customIcons/Raggruppa_68.svg';
import icon_70 from '../../../assets/customIcons/Raggruppa_70.svg';
import icon_71 from '../../../assets/customIcons/Raggruppa_71.svg';
import icon_72 from '../../../assets/customIcons/Raggruppa_72.svg';
import icon_73 from '../../../assets/customIcons/Raggruppa_73.svg';
import icon_74 from '../../../assets/customIcons/Raggruppa_74.svg';
import icon_75 from '../../../assets/customIcons/Raggruppa_75.svg';
import icon_76 from '../../../assets/customIcons/Raggruppa_76.svg';

const messages = defineMessages({
  description: {
    id: 'description',
    defaultMessage: 'Descrizione',
  },
  event_type: {
    id: 'event_type',
    defaultMessage: 'Tipo di evento',
  },
});

const defaultIconWidgetOptions = [
  [icon_68, 'icona 1'],
  [icon_70, 'icona 2'],
  [icon_71, 'icona 3'],
  [icon_72, 'icona 4'],
  [icon_73, 'icona 5'],
  [icon_74, 'icona 6'],
  [icon_75, 'icona 7'],
  [icon_76, 'icona 8'],
];

const IconsListerSidebar = ({
  data,
  block,
  onChangeBlock,
  onChangeSubBlock,
  selected = 0,
  setSelected,
}) => {
  const intl = useIntl();

  return (
    <Segment.Group raised>
      <header className="header pulled">
        <h2>
          <FormattedMessage id="default" defaultMessage="Default" />
        </h2>
      </header>
      <Accordion fluid styled className="form">
        {data.subblocks &&
          data.subblocks.map((subblock, index) => {
            return (
              <div key={'subblock' + index}>
                <Accordion.Title
                  active={selected === index}
                  index={index}
                  onClick={() => setSelected(selected === index ? null : index)}
                >
                  {`icona in posizione ${index}`}
                  {selected === index ? (
                    <Icon name={upSVG} size="20px" />
                  ) : (
                    <Icon name={downSVG} size="20px" />
                  )}
                </Accordion.Title>
                <Accordion.Content active={selected === index}>
                  <IconWidget
                    id="icon"
                    value={subblock.icon}
                    defaultOptions={defaultIconWidgetOptions}
                    onChange={(name, value) => {
                      onChangeSubBlock(index, {
                        ...subblock,
                        icon: value,
                      });
                    }}
                  />
                  <TextWidget
                    id="ArgumentsTitle"
                    title={intl.formatMessage(messages.description)}
                    value={subblock.description}
                    onChange={(name, value) => {
                      onChangeSubBlock(index, {
                        ...subblock,
                        description: value,
                      });
                    }}
                  />
                  <TextWidget
                    id="type"
                    title={intl.formatMessage(messages.event_type)}
                    value={subblock.type}
                    onChange={(name, value) => {
                      onChangeSubBlock(index, {
                        ...subblock,
                        type: value,
                      });
                    }}
                  />
                </Accordion.Content>
              </div>
            );
          })}
      </Accordion>
    </Segment.Group>
  );
};

IconsListerSidebar.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  block: PropTypes.string,
  onChangeBlock: PropTypes.func,
  selected: PropTypes.any,
  setSelected: PropTypes.func,
};

export default injectIntl(IconsListerSidebar);
